import React from "react";
import ComingSoon from "../../components/ComingSoon";

export default function Blog() {
  return <ComingSoon title="Blog & Insights" />;
}
